import { Resource } from '../shared/resource';

export class Reference extends Resource {
  display = 'reference';
  value: string | number = '';
}
